import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M10.076 20.233c5.524 0 10-4.476 10-10s-4.476-10-10-10c-5.523 0-10 4.476-10 10s4.477 10 10 10ZM11.614 5.62l-1.538-1.538-6.154 6.153 1.538 1.54 4.616-1.54-1.538 4.616 1.538 1.539 6.155-6.155-1.538-1.538-4.617 1.539 1.538-4.616Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }